'use strict';

/* eslint no-undef: "off" */
/**
 * XPark announcement bar
 */
define('xparkAnnouncementBar',['xparkHomepageApi', 'appStorage'], function (xparkHomepageApi, appStorage) {
  return {
    template: '\n      <section class="xp-announcement-bar" v-if="announcementList.length">\n        <div class="xp-announcement-viewport" ref="viewport">\n          <div\n            class="xp-announcement-track"\n            :class="{\'is-scrollable\': isScrollable, \'is-centered\': !isScrollable}"\n            :style="trackStyle"\n          >\n            <div class="xp-announcement-content" ref="content">\n              <a\n                v-for="(item, index) in announcementList"\n                :key="item.content + index"\n                class="xp-announcement-link"\n                :href="item.link_url"\n                v-text="item.content"\n              ></a>\n            </div>\n\n            <div\n              v-if="isScrollable"\n              class="xp-announcement-content"\n              aria-hidden="true"\n            >\n              <a\n                v-for="(item, index) in announcementList"\n                :key="\'copy-\' + item.content + index"\n                class="xp-announcement-link"\n                :href="item.link_url"\n                tabindex="-1"\n                v-text="item.content"\n              ></a>\n            </div>\n          </div>\n        </div>\n        <div class="skeleton-loading" v-if="loading"></div>\n      </section>\n    ',
    data: function data() {
      return {
        loading: false,
        isScrollable: false,
        duration: 0,
        announcementList: []
      };
    },
    created: function created() {
      var data = appStorage.get("fetchAnnouncements");
      if (data) {
        this.announcementList = JSON.parse(data);
      }
    },

    computed: {
      trackStyle: function trackStyle() {
        if (!this.isScrollable || !this.duration) {
          return {};
        }

        return {
          animationDuration: this.duration + 's'
        };
      }
    },
    mounted: function mounted() {
      this.fetchAnnouncements();
      this.$nextTick(this.updateScrollable);
      window.addEventListener('resize', this.updateScrollable);
    },
    beforeDestroy: function beforeDestroy() {
      window.removeEventListener('resize', this.updateScrollable);
    },

    methods: {
      fetchAnnouncements: function fetchAnnouncements() {
        var _this = this;

        this.loading = true;
        xparkHomepageApi.getAnnouncements().then(function (data) {
          if (!Array.isArray(data) || !data.length) {
            return;
          }

          _this.announcementList = data.map(function (item) {
            return {
              content: item.content || '',
              link_url: item.link_url || 'javascript:void(0);'
            };
          }).filter(function (item) {
            return item.content;
          });

          _this.$nextTick(_this.updateScrollable);
          appStorage.set("fetchAnnouncements", JSON.stringify(_this.announcementList));
        }).catch(function () {}).finally(function () {
          return _this.loading = false;
        });
      },
      updateScrollable: function updateScrollable() {
        var viewport = this.$refs.viewport;
        var content = this.$refs.content;

        if (!viewport || !content) {
          return;
        }

        var contentWidth = content.scrollWidth;
        var viewportWidth = viewport.clientWidth;

        this.isScrollable = contentWidth > viewportWidth;
        this.duration = Math.max(12, Math.ceil(contentWidth / 24));
      }
    }
  };
});
